'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const ViewShare = require('./share');
const template = require('../templates/thanks.ejs');

module.exports = Backbone.View.extend({
    className: 'view-thanks',
    events: { 
        'click .btn-close': 'closeModal',
        'click .mtv-close': 'routeMTVLink'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render', 'closeModal');

        options = options || {};

        this.user = this.model.user;
        this.native = this.model.native;

        this.shareView = new ViewShare({
          model: options.shareModel,
          isThanks: true,
          shareUrl: options.shareUrl
        });
    },
    /**
     *
     */
    render: function () {

        var model = {
            copy: this.model.copy,
            user: this.shareCopy,
            native: this.model.native
        };

        this.$el.html(template(model));
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        if(this.native) this.$el.addClass('native');
        this.$el.find('.share').html(this.shareView.render().$el);
    },
    /**
     * [closeModal description]
     * @return {[type]} [description]
     */
    closeModal: function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        if(parseInt(this.model.copy.route_social_category)) {
            PubSub.trigger('openSocialCategory');
            return;
        }
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * 
     */
    routeMTVLink: function(e) {
        var href = e.currentTarget.href;
        var omParams = { name: 'link to mtv', section: 'thanks-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Close Thanks Modal to MTV' };

        PubSub.trigger( 'linkClick', omParams, gaParams);
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {
        this.shareView.remove();
        this.share = null;
        this.user = null;
        Backbone.View.prototype.remove.call(this);
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/thanks.js